module.exports = __webpack_public_path__ + "static/media/AB_L31_4.e81fd70f.jpg";